<template>
	<div>
		<div class="upload-imgs clearfix">
			<div class="upload-img" v-for="(item, index) in multiTempPicsList" :key="index" :style="style_">
				<img class="upload-img__img" :src="BASE_URL(item)" />
				<img class="upload-img__close" src="~@/assets/img/culturalCircles/circle_close_btn@2x.png" @click="deleteImg(item.id)" />
			</div>
			<div class="upload-img upload-img__add" v-if="maxCount_ > multiTempPicsList.length" :style="style_">
				<input type="file" @change="changeFile" accept="image/jpg, image/png, image/jpeg, image/gif" :multiple="multiple_" />
				<span class="upload-img__text">上传照片</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {BASE_URL} from "@/config";

  export default {
		data() {
			return {
				multiTempPicsList: [], //临时目录
				multiPicsList: [], //已经完成目录
				prevId: ''
			}
		},
		props: {
			tips: {
				type: String,
				default: ''
			},
			width: {
				type: String,
				default: '160px'
			},
			value: {
				type: Array,
				default: () => {
					return []
				}
			},
			height: {
				type: String,
				default: '160px'
			},
			maxCount: {
				type: [Number, String],
				default: 1
			}
		},
		computed: {
			maxCount_() {
				let maxCount = parseInt(this.maxCount);
				console.log(maxCount);
				return isNaN(maxCount) ? 1 : maxCount;
			},
			multiple_() {
				return (this.maxCount_ - this.multiTempPicsList.length > 1) ? 'multiple' : false;
			},
			lastCount_() {
				return this.maxCount_ - this.multiTempPicsList.length;
			},
			style_() {
				return {
					width: this.width,
					height: this.height
				}
			}
		},
		created() {
			this.prevId = 'id' + this._uid;
		},
		watch: {
			multiTempPicsList: {
				handler(val) {
					this.$emit('add', val)
				},
				deep: true
			},
			multiPicsList: {
				handler(val) {
					this.$emit('change', val)
				},
				deep: true
			},
			value: {
				handler(val) {
					let randomStr = Math.random().toString(32).substr(2);
					let initVal = val.map((o, i) => {
						return {
							id: 'id' + randomStr + i,
							fileUrl: o
						}
					})
					this.multiPicsList = initVal.concat();
					this.multiTempPicsList = initVal.concat();
				},
				deep: true
			}
		},
		methods: {
      BASE_URL(item) {
        console.log("url:"+item)
        if (item && item.fileUrl && item.fileUrl.substring(0, 3) === '/u/') {
          return BASE_URL + item.fileUrl
        } else {
          if(item) {
            if(item.fileUrl.indexOf("data:") !== -1){
              return item.fileUrl.substring(item.fileUrl.indexOf("data:"),item.fileUrl.length)
            }
            return item.fileUrl;
          } else {
            return undefined;
          }
        }
      },
			// 删除图片
			deleteImg(id) {
				let index = this.multiTempPicsList.findIndex(o => o.id === id);
				let index1 = this.multiPicsList.findIndex(o => o.id === id);
				index !== -1 && this.multiTempPicsList.splice(index, 1);
				index1 !== -1 && this.multiPicsList.splice(index1, 1);
			},
			changeFile(e) {
				let files = e.target.files;
				let len = files.length 
				if(len > this.lastCount_){
					this.$toast('已自动过滤多余图片');
				}
				len = len > this.lastCount_ ? this.lastCount_ : len;
				for(var i = 0;i < len; i++){
					var file = files[i] || files.item(i);
					this.getImgURL(file , this.upload);
				}
			},
			// 选择图片
			upload(temp, imgBase) {
				let id = 'id' + Math.random().toString(32).substr(2)
				let index = this.multiTempPicsList.push({
					id: id,
					fileUrl: imgBase
				});
				this.$upload(temp, (res) => {
					if (res.code === 1) {
						this.multiTempPicsList.findIndex(o => o.id === id) !== -1 && this.multiPicsList.push({
							id: id,
							resourceId: res.data.resourceId,
							fileUrl: res.data.fileUrl
						});
					}else{
            this.$toast(res.msg)
            this.multiTempPicsList.splice(index - 1, 1)
          }
				})
			},
			getImgURL(file, baseCall) {
				var imgURL = "";
				try {
					try {
						//Firefox7.0   
						imgURL = file.getAsDataURL();
						imgRUL && baseCall && baseCall(file, imgRUL);
						//alert("//Firefox7.0"+imgRUL);                           
					} catch (e) {
						//Firefox8.0以上          
						imgRUL = window.URL.createObjectURL(file);
						imgRUL && baseCall && baseCall(file, imgRUL);
						//alert("//Firefox8.0以上"+imgRUL);  
					}
				} catch (e) { //这里不知道怎么处理了，如果是遨游的话会报这个异常                   
					//支持html5的浏览器,比如高版本的firefox、chrome、ie10  
					var reader = new FileReader();
					reader.onload = function(res) {
						baseCall && baseCall(file, res.target.result);
					};
					reader.readAsDataURL(file);
				}
			}
		}
	}
</script>

<style lang="scss">
	.upload-imgs {
		display: flex;
		flex-wrap: wrap;
		padding-top: 10px;

		.upload-img {
			margin-bottom: 10px;
			margin-right: 10px;
			width: 30%;
			height: 225px;
			text-align: center;
			background: rgba(244, 247, 251, 1);
			border-radius: 12px;
			font-size: 28px;
			overflow: hidden;
			font-weight: 400;
			color: rgba(171, 189, 214, 1);
			position: relative;
			line-height: 60px;

			image {
				border-radius: 12px;
			}
			
			.upload-img__img{
				width: 100%;
				height: 100%;
				display: block;
			}

			.upload-img__close {
				width: 38px;
				height: 38px;
				@include abs(0, 0);
			}

			&:nth-of-type(3n) {
				margin-right: -20px;
				float: right;
			}

			&.upload-img__add {
				background: #F4F7FB url(~@/assets/img/culturalCircles/circle_upload_img@2x.png) center 30% no-repeat;
				background-size: 30%;
				overflow: hidden;

				input {
					@include abs(0, 0, 0, 0);
					width: 100%;
					height: 100%;
					z-index: 99;
					opacity: 0;
				}

				.upload-img__text {
					@include abs(null, 10px, 10%, 10px);
					font-size: 16px;
					text-align: center;
					color: #ABBDD6;
				}
			}
		}
	}
</style>
